var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"menu-close","transform":"translate(-4.222 -4.222)"},[React.createElement("line",{"data-name":"Ligne 22","x2":"18","transform":"translate(5.636 18.364) rotate(-45)","fill":"currentColor","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"data-name":"Ligne 24","x2":"18","transform":"translate(5.636 5.636) rotate(45)","fill":"currentColor","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

MenuClose.defaultProps = {"width":"15.556","height":"15.556","viewBox":"0 0 15.556 15.556"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
